// Display the approved artwork verbatim. The viewBox removes only empty margins.
export default function BrandLogo() {
  return <svg className="wozzap-logo" viewBox="190 150 1800 435" role="img" aria-label="wozzap.it" focusable="false">
    <image href="/branding/wozzap-logo-v2.png" width="2172" height="724" />
  </svg>;
}
